import { render, staticRenderFns } from "./PaymentMessageReservationFilter.vue?vue&type=template&id=5b8caf73&scoped=true&"
import script from "./PaymentMessageReservationFilter.vue?vue&type=script&lang=js&"
export * from "./PaymentMessageReservationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8caf73",
  null
  
)

export default component.exports